import { useTranslation } from "@redotech/redo-i18n";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo, useState } from "react";

export const ConfirmDeleteReturnViewFolderModal = memo(
  function ConfirmDeleteReturnViewFolderModal({
    isOpen,
    onClose,
    onConfirm,
    folderName,
  }: {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    folderName: string;
  }) {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleConfirm = async () => {
      setIsSubmitting(true);
      try {
        await onConfirm();
        onClose();
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <RedoModal
        isOpen={isOpen}
        modalSize="sm"
        onModalCloseRequested={isSubmitting ? () => {} : onClose}
        primaryButton={{
          text: t("Delete"),
          onClick: handleConfirm,
          disabled: isSubmitting,
          theme: "destructive",
          size: "sm",
        }}
        secondaryButton={{
          text: t("Cancel"),
          onClick: onClose,
          disabled: isSubmitting,
          size: "sm",
        }}
        subtitle={t(
          'Are you sure you want to delete the folder "{{folderName}}"?',
          { folderName },
        )}
        title={t("Delete folder")}
      />
    );
  },
);
